"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="AppointmentHeader.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxAppointmentHeader object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxAppointmentHeader = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxAttendeeData_1 = require("./HxAttendeeData");
var HxTimeZoneRule_1 = require("./HxTimeZoneRule");
var HxTimeSpan_1 = require("./HxTimeSpan");
var HxDailyPattern_1 = require("./HxDailyPattern");
var HxEndDatePatternRange_1 = require("./HxEndDatePatternRange");
var HxMonthlyAbsolutePattern_1 = require("./HxMonthlyAbsolutePattern");
var HxMonthlyRelativePattern_1 = require("./HxMonthlyRelativePattern");
var HxNoEndPatternRange_1 = require("./HxNoEndPatternRange");
var HxNumberedPatternRange_1 = require("./HxNumberedPatternRange");
var HxWeeklyPattern_1 = require("./HxWeeklyPattern");
var HxYearlyAbsolutePattern_1 = require("./HxYearlyAbsolutePattern");
var HxYearlyRelativePattern_1 = require("./HxYearlyRelativePattern");
var HxTimeRange_1 = require("./HxTimeRange");
var HxAppointmentHeader = /** @class */ (function (_super) {
    __extends(HxAppointmentHeader, _super);
    function HxAppointmentHeader(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxAppointmentHeader, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxAppointmentHeader.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '228':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case 'CA7':
                        this.appointmentBodyId = new HxObjectID_1.default(v);
                        break;
                    case 'C0F':
                        this.attendeesCount = v;
                        break;
                    case 'C10':
                        var attendeesForPreviewValues = v;
                        this.attendeesForPreview = new Array(attendeesForPreviewValues.length);
                        for (var i = 0; i < attendeesForPreviewValues.length; i++) {
                            this.attendeesForPreview[i] = HxAttendeeData_1.deserializeHxAttendeeData(attendeesForPreviewValues[i]);
                        }
                        break;
                    case '1080':
                        this.bodyChangeKey = Buffer.from(v, 'base64');
                        break;
                    case '21F':
                        this.bodyPreview = v;
                        break;
                    case '353':
                        this.bodySyncDownloadResult = v;
                        break;
                    case '221':
                        this.bodyUpToDate = v;
                        break;
                    case '203':
                        this.calendarHandle = v;
                        break;
                    case '1134':
                        this.calendarItemReferenceId = v;
                        break;
                    case '1229':
                        this.canDelete = v;
                        break;
                    case '122A':
                        this.canModify = v;
                        break;
                    case '22C':
                        this.capabilities_CanAccept = v;
                        break;
                    case '230':
                        this.capabilities_CanCancel = v;
                        break;
                    case '22E':
                        this.capabilities_CanDecline = v;
                        break;
                    case '22A':
                        this.capabilities_CanDelete = v;
                        break;
                    case '229':
                        this.capabilities_CanEdit = v;
                        break;
                    case '22B':
                        this.capabilities_CanForward = v;
                        break;
                    case '232':
                        this.capabilities_CanNotifyInvitees = v;
                        break;
                    case '231':
                        this.capabilities_CanNotifyOrganizer = v;
                        break;
                    case '22F':
                        this.capabilities_CanProposeNewTime = v;
                        break;
                    case '234':
                        this.capabilities_CanReplyToAll = v;
                        break;
                    case '233':
                        this.capabilities_CanReplyToOrganizer = v;
                        break;
                    case '22D':
                        this.capabilities_CanTentativelyAccept = v;
                        break;
                    case '211':
                        var categoriesValues = v;
                        this.categories = new Array(categoriesValues.length);
                        for (var i = 0; i < categoriesValues.length; i++) {
                            this.categories[i] = categoriesValues[i];
                        }
                        break;
                    case '20B':
                        this.changeKey = Buffer.from(v, 'base64');
                        break;
                    case '38D':
                        this.charm = v;
                        break;
                    case 'F8F':
                        this.createCalendarItemState = v;
                        break;
                    case 'AFA':
                        this.createdTime = new Date(v);
                        break;
                    case '204':
                        this.deviceId = v;
                        break;
                    case '127E':
                        var endTimeZoneIANAValues = v;
                        this.endTimeZoneIANA = new Array(endTimeZoneIANAValues.length);
                        for (var i = 0; i < endTimeZoneIANAValues.length; i++) {
                            this.endTimeZoneIANA[i] = endTimeZoneIANAValues[i];
                        }
                        break;
                    case '208':
                        this.endTimeZoneId = v;
                        break;
                    case '209':
                        this.endTimeZoneRule = HxTimeZoneRule_1.deserializeHxTimeZoneRule(v);
                        break;
                    case '21B':
                        this.expansionType = v;
                        break;
                    case '218':
                        this.freeBusyState = v;
                        break;
                    case '69E':
                        this.globalObjectId = v;
                        break;
                    case 'EDC':
                        this.hasAttachments = v;
                        break;
                    case '214':
                        this.hasAttendees = v;
                        break;
                    case '1443':
                        this.importedFromICS = v;
                        break;
                    case '212':
                        this.isAllDay = v;
                        break;
                    case '21C':
                        this.isCancelled = v;
                        break;
                    case '12D2':
                        this.isDraft = v;
                        break;
                    case '586':
                        this.isMeetingPoll = v;
                        break;
                    case '3FF':
                        this.isMissingData = v;
                        break;
                    case '220':
                        this.isOnlineMeeting = v;
                        break;
                    case '20E':
                        this.isOrganizer = v;
                        break;
                    case '225':
                        this.isPlaceholder = v;
                        break;
                    case '215':
                        this.isReminderSet = v;
                        break;
                    case 'AFB':
                        this.lastModifiedTime = new Date(v);
                        break;
                    case '49C':
                        this.linkedEmail_ConversationServerId = v;
                        break;
                    case '57E':
                        this.linkedEmail_MessageServerId = v;
                        break;
                    case '49B':
                        this.linkedEmail_ViewServerId = v;
                        break;
                    case '20D':
                        this.location = v;
                        break;
                    case 'B4B':
                        this.masterId = new HxObjectID_1.default(v);
                        break;
                    case 'ADE':
                        this.masterServerId = v;
                        break;
                    case '12C2':
                        this.normalizedSubject = v;
                        break;
                    case '20F':
                        this.organizer_DisplayName = v;
                        break;
                    case '210':
                        this.organizer_EmailAddress = v;
                        break;
                    case '21E':
                        this.originalStartDate = new Date(v);
                        break;
                    case '100A':
                        this.ownedBySearch = v;
                        break;
                    case '216':
                        this.reminderLeadTime = HxTimeSpan_1.deserializeHxTimeSpan(v);
                        break;
                    case '12B1':
                        this.reminderNextTime = new Date(v);
                        break;
                    case '59C':
                        this.reminderTime = new Date(v);
                        break;
                    case '21A':
                        this.repeatItemType = v;
                        break;
                    case '1591':
                        this.repeatSeriesData_DailyPattern = HxDailyPattern_1.deserializeHxDailyPattern(v);
                        break;
                    case '1592':
                        this.repeatSeriesData_EndDatePatternRange = HxEndDatePatternRange_1.deserializeHxEndDatePatternRange(v);
                        break;
                    case '1593':
                        this.repeatSeriesData_MonthlyAbsolutePattern = HxMonthlyAbsolutePattern_1.deserializeHxMonthlyAbsolutePattern(v);
                        break;
                    case '1594':
                        this.repeatSeriesData_MonthlyRelativePattern = HxMonthlyRelativePattern_1.deserializeHxMonthlyRelativePattern(v);
                        break;
                    case '1595':
                        this.repeatSeriesData_NoEndPatternRange = HxNoEndPatternRange_1.deserializeHxNoEndPatternRange(v);
                        break;
                    case '1596':
                        this.repeatSeriesData_NumberedPatternRange = HxNumberedPatternRange_1.deserializeHxNumberedPatternRange(v);
                        break;
                    case '1597':
                        this.repeatSeriesData_Pattern = v;
                        break;
                    case '1598':
                        this.repeatSeriesData_PatternRange = v;
                        break;
                    case '1599':
                        this.repeatSeriesData_WeeklyPattern = HxWeeklyPattern_1.deserializeHxWeeklyPattern(v);
                        break;
                    case '159A':
                        this.repeatSeriesData_YearlyAbsolutePattern = HxYearlyAbsolutePattern_1.deserializeHxYearlyAbsolutePattern(v);
                        break;
                    case '159B':
                        this.repeatSeriesData_YearlyRelativePattern = HxYearlyRelativePattern_1.deserializeHxYearlyRelativePattern(v);
                        break;
                    case '21D':
                        this.responseRequested = v;
                        break;
                    case '213':
                        this.responseStatus = v;
                        break;
                    case '45B':
                        this.responseTime = new Date(v);
                        break;
                    case '226':
                        this.roamingId = v;
                        break;
                    case 'FF9':
                        this.searchDataId = new HxObjectID_1.default(v);
                        break;
                    case '219':
                        this.sensitivity = v;
                        break;
                    case '20A':
                        this.serverId = v;
                        break;
                    case '127F':
                        var startTimeZoneIANAValues = v;
                        this.startTimeZoneIANA = new Array(startTimeZoneIANAValues.length);
                        for (var i = 0; i < startTimeZoneIANAValues.length; i++) {
                            this.startTimeZoneIANA[i] = startTimeZoneIANAValues[i];
                        }
                        break;
                    case '206':
                        this.startTimeZoneId = v;
                        break;
                    case '207':
                        this.startTimeZoneRule = HxTimeZoneRule_1.deserializeHxTimeZoneRule(v);
                        break;
                    case '20C':
                        this.subject = v;
                        break;
                    case 'AFC':
                        this.tailoredDetailsChangeNumber = v;
                        break;
                    case '38F':
                        this.tailoredEventDetails = v;
                        break;
                    case '38E':
                        this.tailoredEventType = v;
                        break;
                    case '205':
                        this.timeRangeUtc = HxTimeRange_1.deserializeHxTimeRange(v);
                        break;
                    case '227':
                        this.uri = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxAppointmentHeader.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxAppointmentHeader.prototype.getAppointmentBody = function (sessionId) {
        return this.activeSet.getObject(this.appointmentBodyId, sessionId).then(function (result) { return result; });
    };
    HxAppointmentHeader.prototype.getCalendar = function (sessionId) {
        return this.activeSet.getObjectFromHandle(this.calendarHandle, HxObjectType_1.default.HxCalendarData, sessionId).then(function (result) { return result; });
    };
    HxAppointmentHeader.prototype.getMaster = function (sessionId) {
        return this.activeSet.getObject(this.masterId, sessionId).then(function (result) { return result; });
    };
    HxAppointmentHeader.prototype.getSearchData = function (sessionId) {
        return this.activeSet.getCollection(this.searchDataId, sessionId);
    };
    return HxAppointmentHeader;
}(HxObject_1.default));
exports.HxAppointmentHeader = HxAppointmentHeader;
exports.default = HxAppointmentHeader;
